import React, { Children } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import { withStyles } from "@mui/styles";
import { COLORS } from "../utils/colors";

const CustomTabList = withStyles(() => ({
  indicator: {
    backgroundColor: COLORS.OXYGEN7_PURPLE
  },
  flexContainer: {
    // "& button + button": {
    //   margin: '1px solid #000'
    // },
    "& button:focus": {
      outline: "none"
    },
    "& button:is(.Mui-selected)": {
      color: COLORS.OXYGEN7_PURPLE
    }
  },
}))(TabList);

const TabsMenu = ({ value, onChange, children }) => {
  const tabs = Children.toArray(children).filter((child) => child.type === Tab);

  const tabPanels = Children.toArray(children).filter(
    (child) => child.type === TabPanel
  );

  const box = Children.toArray(children).filter((child) => child.type === Box);

  return (
    <TabContext value={value}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <CustomTabList onChange={onChange}>{tabs}</CustomTabList>
        {box}
      </Box>
      {tabPanels.map((panel) =>
        React.cloneElement(panel, { sx: { px: 0 } })
      )}
    </TabContext>
  );
};

export default TabsMenu;
